/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOpusIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetOpusIdQuery = { __typename: 'Query', getCampaign: { __typename: 'Campaign', artist: { __typename: 'Artist', opus_id: string | null } | null } | null };


export const GetOpusIdDocument = gql`
    query getOpusId($id: String!) {
  getCampaign(id: $id) {
    artist {
      opus_id
    }
  }
}
    `;

/**
 * __useGetOpusIdQuery__
 *
 * To run a query within a React component, call `useGetOpusIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpusIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpusIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOpusIdQuery(baseOptions: Apollo.QueryHookOptions<GetOpusIdQuery, GetOpusIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpusIdQuery, GetOpusIdQueryVariables>(GetOpusIdDocument, options);
      }
export function useGetOpusIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpusIdQuery, GetOpusIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpusIdQuery, GetOpusIdQueryVariables>(GetOpusIdDocument, options);
        }
export type GetOpusIdQueryHookResult = ReturnType<typeof useGetOpusIdQuery>;
export type GetOpusIdLazyQueryHookResult = ReturnType<typeof useGetOpusIdLazyQuery>;